import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { FaCheck, FaPlay } from "react-icons/fa6";
import { IoMdLock } from "react-icons/io";
import Link from "@mui/material/Link";

// Components
import Tooltip from "../../../components/tooltip";

// Styles
import styles from "./item.module.scss";
import { MaterialCompletionStatus, Unit } from "../../../types";



interface RoadMapItemProps {
  item: Unit;
  index: number;
  nextStatus: MaterialCompletionStatus | null;
}

const RoadMapItem = forwardRef<HTMLDivElement, RoadMapItemProps>(({ item, index, nextStatus }, ref) => {
  const { t } = useTranslation();
  // Render
  if (!item) return null;

  const renderIcon = () => {
    if (item.state === "done") return <FaCheck className={`${styles.icon} text-emerald-300`} />;
    if (item.state === "locked") return <IoMdLock className={`${styles.icon} text-gray-500`} />;
    return <FaPlay className={`${styles.icon} text-white`} />;
  };

  const renderItemTrail = () => {
    if (!nextStatus) return null;
    let trailClass = styles.itemTrail;

    const status = item.state;

    switch ([status, nextStatus]) {
      case ["done", "done"]:
        trailClass += ` ${styles.greenTrail}`;
        break;
      case ["locked", "unlocked"]:
      case ["unlocked", "locked"]:
      case ["locked", "locked"]:
      case ["unlocked", "unlocked"]:
        trailClass += ` ${styles.purpleTrail}`;
        break;
      case ["done", "locked"]:
      case ["done", "unlocked"]:
        trailClass += ` ${styles.purpleToGreenTrail}`;
      case ["locked", "done"]:
      case ["unlocked", "done"]:
        trailClass += ` ${styles.greenToPurpleTrail}`;
        break;
    }

    // if (status === "done" && nextStatus === "done") trailClass += ` ${styles.greenTrail}`;
    // else if (status === "locked" && nextStatus === "unlocked" ||
    //   status === "unlocked" && nextStatus === "locked" ||
    //   status === "locked" && nextStatus === "locked" ||
    //   status === "unlocked" && nextStatus === "unlocked"
    // ) {
    //   trailClass += ` ${styles.purpleTrail}`;
    // }
    // else if (status === "done" && nextStatus === "locked") trailClass += ` ${styles.purpleToGreenTrail}`;
    // else if (status === "locked" && nextStatus === "done") trailClass += ` ${styles.greenToPurpleTrail}`;
    // else if (status === "done" && nextStatus === "unlocked") trailClass += ` ${styles.purpleToGreenTrail}`;
    // else if (status === "unlocked" && nextStatus === "done") trailClass += ` ${styles.greenToPurpleTrail}`;

    return <div className={trailClass} />;
  }

  const renderButton = () => {
    let buttonClass = `${styles.button}`;
    if (item.state === "done") buttonClass += ` ${styles.doneButton}`;
    else if (item.state === "locked") buttonClass += ` ${styles.lockedButton}`;
    else if (item.state === "unlocked") buttonClass += ` ${styles.unlockedButton}`;

    const buttonNode = (
      <button className={buttonClass}>
        {renderIcon()}
      </button>
    )

    if (item.state === 'unlocked') {
      const tooltipNode = (
        <div className='text-sm text-blue-500 '>
          {t("roadMap.proceed_to_stage", { stage: index + 1 })}
        </div>
      )

      return (
        <Tooltip open label={tooltipNode} classes={{ tooltip: styles.tooltipNode }}>
          {buttonNode}
        </Tooltip>
      )
    }

    return buttonNode;
  }

  if (item.state === 'locked') {
    return (
      <div ref={ref} className={`${styles.itemContainer}`}>
        {renderItemTrail()}

        {renderButton()}
      </div>
    )
  } else {
    return (
      <Link ref={ref} className={`${styles.itemContainer}`} href={`${item?.content_material?.url}?back_path=${location.pathname}`}>
        {renderItemTrail()}

        {renderButton()}
      </Link>
    )
  }

});

RoadMapItem.displayName = 'RoadMapItem';

export default RoadMapItem;
